
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "customTable",
  props: {
    table: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: Number as PropType<number>,
    },
    tableConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    usePagination: {
      type: Boolean,
      default: true,
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    rowClassName: {
      type: Function || Object,
    },
  },
  emits: ["update:currentPage"],
  methods: {
    modelPageChange(value: string) {
      this.$emit("update:currentPage", value);
    },
    clearSort() {
      (this.$refs as any).elTable.clearSort();
    },
  },
});
